var Size = function (_x, _y, _z) {
  /* Stored in mm */
  this.x = _x;
  this.y = _y;
  this.z = _z;
  this.designerScale = 1;
  this.userScale = 1;
  this.units = { mm: 0.1, cm: 1, m: 100, in: 2.54, ft: 30.48, yd: 91.44 };
  this.unit = "cm";
  this.minScale = 0.0;
};

Size.prototype = {
  get: function () {
    return {
      x: this.x * this.userScale * this.designerScale,
      y: this.y * this.userScale * this.designerScale,
      z: this.z * this.userScale * this.designerScale,
    };
  },

  maxScale: function (container) {
    // Container is an array [x,y,z], returns the max scale
    container.sort(function (a, b) {
      return a - b;
    });

    var box = [
      this.x * this.unitFactor(),
      this.y * this.unitFactor(),
      this.z * this.unitFactor(),
    ];

    box.sort(function (a, b) {
      return a - b;
    });

    return Math.min(
      container[0] / box[0],
      container[1] / box[1],
      container[2] / box[2]
    );
  },

  setMinScale: function (scale, unit) {
    // Container is an array [x,y,z], returns the max scale
    this.minScale = scale * this.units[unit];
  },

  getMinScale: function () {
    return this.minScale / this.unitFactor();
  },

  fits: function (container) {
    // Container is an array [x,y,z], returns a bool if the design fits the container
    container.sort(function (a, b) {
      return a - b;
    });

    var s = this.get();
    var box = [
      s.x * this.unitFactor(),
      s.y * this.unitFactor(),
      s.z * this.unitFactor(),
    ];

    box.sort(function (a, b) {
      return a - b;
    });

    return (
      box[0] <= container[0] && box[1] <= container[1] && box[2] <= container[2]
    );
  },

  unitFactor: function (unit) {
    unit = unit || this.unit;
    return this.units[unit];
  },

  scaleFactor: function (scale, unit) {
    scale = scale || this.userScale;
    return this.designerScale * scale * this.unitFactor(unit) * 10; // In mm
  },

  fixed: function (p) {
    var s = this.get();

    return {
      x: this.fixedFloat(s.x, p),
      y: this.fixedFloat(s.y, p),
      z: this.fixedFloat(s.z, p),
    };
  },

  fixedFloat: function (f, p) {
    /* The float f and the precision p */
    var precision = p ? p : 3;
    var nicePrecision = Math.max(
      0,
      precision + 1 - (Math.round(f) + "").length
    );

    return f.toFixed(nicePrecision); // Return a string like this : 1.000 / 10.00 / 100.0 / 1000 if p=3
  },

  toFixed: function (p) {
    var s = this.get();

    return {
      x: parseFloat(s.x.toFixed(p)),
      y: parseFloat(s.y.toFixed(p)),
      z: parseFloat(s.z.toFixed(p)),
    };
  },

  clone: function () {
    var size = new Size(this.x, this.y, this.z);

    $.extend(true, size, this);

    return size;
  },
};
